import * as React from 'react'
import ContentLoader from 'react-content-loader'
import { AvatrLoaderProps } from './interface'

export const AvatarLoader: React.FC<AvatrLoaderProps> = ({ height }) => (
  <ContentLoader height={102} width={102} speed={2} primaryColor="#f3f3f3" secondaryColor="#ecebeb" style={{ height }}>
    <circle cx="52" cy="52" r="51" />
  </ContentLoader>
)
